import { Table } from "@/features/Table";
import { k1_documents_columns } from "./columns";

const client = "k1";
const table_name = "k1_documents";

export function K1DocumentsTable() {
  return (
    <Table<Record<string, unknown>, unknown>
      label="K1 documents"
      client={client}
      table_name={table_name}
      columns={k1_documents_columns}
    />
  );
}
